export default __webpack_public_path__ + "static/2478-524e430f0f2b5b1f351dba761295c7d8.jpeg";